module.exports = __webpack_public_path__ + "29e92a1f76cf609de8e9c51ebf9f0905.svg";